import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import ImageSlider from '../components/ImageSlider';

function Home() {
  return (
    <>
      <Hero />
      <Stats />
      <ImageSlider />
    </>
  );
}

export default Home;
